import * as React from 'react'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'

import Grid from '@mui/material/Grid'
import ImportMenuItem from '../MenuItem'
import Container from '@mui/material/Container'

import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Dialog from '@mui/material/Dialog'
import LoadingButton from '@mui/lab/LoadingButton'
import Link from '@mui/material/Link'

import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import StepButton from '@mui/material/StepButton'

import Typography from '@mui/material/Typography'

import ArrowForwardIcon from '@mui/icons-material/ArrowForwardOutlined'
import MultipleSelect from '../MultiSelect'
import EditableSelect from '../EditableSelect'

import TextField from '@mui/material/TextField'

import {
    useContextsStore,
    selectOwnedContexts,
} from '../../stores/useContextsStore'
import { UserContext } from '../../UserContext'

import { useTheme } from '@mui/material/styles'

import { generateSyncImportItems } from './SyncImportItems'

import { SubImportContext } from './SubImportContext'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'

import axios from 'axios'
import qs from 'qs'
import { importErrorMessage } from './importError'


const steps = ['Sources', 'Settings', 'Destination']

export default function NewsImportDialog({ contextName, open, onClose }) {
    const theme = useTheme() // hook to get the current theme

    const {
        activeSubImportDialog,
        setActiveSubImportDialog,
    } = React.useContext(SubImportContext)

    const [presetContext, setPresetContext] = React.useState(
        generatePresetContext()
    )

    const [selectedContext, addToSelectedContext] = React.useState(contextName)

    const [errorMessage, setErrorMessage] = React.useState(null)

    const [importError, setImportError] = React.useState(null)

    const [selectedFeeds, setSelectedFeeds] = React.useState([])

    const [completedSteps, setCompletedSteps] = React.useState([])

    const [visitedContext, setVisitedContext] = React.useState(false)

    const [includeTeasers, setIncludeTeasers] = React.useState(false)

    const { username } = React.useContext(UserContext)

    const menuItems = generateSyncImportItems()

    const contexts = useContextsStore(selectOwnedContexts)
    const contextNames = contexts.map(c => c.name)

    const handleChange = (_, newValue) => {
        setValue(newValue)
    }

    const [activeStep, setActiveStep] = React.useState(0)
    const [skipped, setSkipped] = React.useState(new Set())

    const isStepOptional = step => {
        return step === 1
    }

    const isStepSkipped = step => {
        return skipped.has(step)
    }

    const handleNext = () => {
        let newSkipped = skipped
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values())
            newSkipped.delete(activeStep)
        }

        setActiveStep(prevActiveStep => prevActiveStep + 1)
        setSkipped(newSkipped)
    }

    React.useEffect(() => {
        addToSelectedContext(presetContext)
    }, [presetContext])

    const submitDataForm = () => {
        const rssInputString = selectedFeeds.join('\r\n')

        const dataToSend = {
            source: 'rss',
            rssinput: rssInputString,
            urlselect: 'news',
            rsssince: '',
            rssitems: '50',
            includeteasers: includeTeasers.toString(),
            search: '',
            context: selectedContext,
            selectedContexts: '',
            statementid: '',
            removetags: '',
        }

        const dataAsForm = qs.stringify(dataToSend)

        axios
            .post('/import/rss', dataAsForm, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded', // Sending as URL-encoded form data
                },
            })
            .then(response => {
                if (response.data.redirectUrl) {
                    // If you're using window.location
                    window.location.href = response.data.redirectUrl

                    // Or, if you're using React Router's history (assuming you have access to the history object)
                    // history.push(response.data.redirectUrl);
                } else {
                    console.error(`Did't receive any response from the server.`)
                    if (response.data.error) {
                        setErrorMessage(
                            typeof response.data.error == 'object'
                                ? response.data.error.error ||
                                      JSON.stringify(response.data.error)
                                : response.data.error
                        )
                        setImportError(response.data.error)
                        setActiveStep(1)
                    }
                }
            })
            .catch(error => {
                // Handle the error here
                console.error('Received the following error', error)
                setErrorMessage(importErrorMessage(error))
                setImportError(response.data.error)
            })
    }

    const handleBack = () => {
        setActiveStep(prevActiveStep => prevActiveStep - 1)
    }

    const handleSkip = () => {
        if (!isStepOptional(activeStep)) {
            // You probably want to guard against something like this,
            // it should never occur unless someone's actively trying to break something.
            throw new Error("You can't skip a step that isn't optional.")
        }

        setActiveStep(prevActiveStep => prevActiveStep + 1)
        setSkipped(prevSkipped => {
            const newSkipped = new Set(prevSkipped.values())
            newSkipped.add(activeStep)
            return newSkipped
        })
    }

    const handleReset = () => {
        setActiveStep(0)
    }

    const handleTeasersChange = () => {
        if (includeTeasers) {
            setIncludeTeasers(false)
            return 'false'
        } else {
            setIncludeTeasers(true)
            return 'true'
        }
    }

    React.useEffect(() => {
        if (activeSubImportDialog.content) {
            setActiveStep(1)
            setSelectedFeeds(activeSubImportDialog.content)
        }
    }, [activeSubImportDialog])

    React.useEffect(() => {
        setImportError(null)
    }, [selectedFeeds])

    React.useEffect(() => {
        switch (activeStep) {
            case 1:
                if (selectedFeeds.length > 0) {
                    setCompletedSteps([...completedSteps, 0, 1])
                    if (!importError) {
                        setErrorMessage(null)
                    }

                    setPresetContext(
                        generatePresetContext(activeSubImportDialog.type)
                    )
                    break
                }
                setErrorMessage('Please, select at least one feed.')
                break
            case 2:
                if (selectedFeeds.length > 0) {
                    if (
                        completedSteps.indexOf(1) >= 0 &&
                        !selectedContext &&
                        visitedContext
                    ) {
                        setErrorMessage(
                            'Please, select the graph to import your data to.'
                        )
                        break
                    }
                    setCompletedSteps([...completedSteps, 0, 1])
                    setErrorMessage(null)
                    setVisitedContext(true)

                    break
                }
                setActiveStep(1)
                break
            case 3:
                if (selectedContext) {
                    setCompletedSteps([...completedSteps, 2])
                    setErrorMessage(null)
                    submitDataForm()
                    break
                }
                setActiveStep(2)
                break
        }
    }, [activeStep])

    const handleStep = step => {
        setActiveStep(step)
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={onClose}
                fullWidth={true}
                maxWidth="lg"
            >
                <DialogTitle
                    sx={{
                        padding: 4,
                        color: theme => theme.palette.text.primary,
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    {
                        'Sync Data from External Sources to Reveal the Main Topics and Gaps in a Discourse'
                    }
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={onClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <Stepper
                    activeStep={activeStep}
                    sx={{ paddingLeft: 4, paddingRight: 4, paddingTop: 2 }}
                >
                    {steps.map((label, index) => {
                        const stepProps = {}
                        const labelProps = {}
                        // if (isStepOptional(index)) {
                        //     labelProps.optional = (
                        //         <Typography variant="caption">
                        //             Optional
                        //         </Typography>
                        //     )
                        // }
                        if (isStepSkipped(index)) {
                            stepProps.completed = false
                        }
                        return (
                            <Step key={label} {...stepProps}>
                                <StepButton
                                    onClick={() => handleStep(index)}
                                    completed={(
                                        completedSteps.indexOf(index) >= 0
                                    ).toString()}
                                >
                                    <StepLabel
                                        {...labelProps}
                                        sx={{
                                            '& .MuiStepLabel-label': {
                                                fontSize: {
                                                    xs: '0.75rem',
                                                    sm: 'initial',
                                                },
                                            },
                                        }}
                                    >
                                        {label}
                                    </StepLabel>
                                </StepButton>
                            </Step>
                        )
                    })}
                </Stepper>

                {errorMessage && (
                    <Typography
                        sx={{
                            paddingRight: 4,
                            paddingLeft: 4,
                            paddingTop: 4,
                            paddingBottom: 0,
                        }}
                        color="error"
                        component="div"
                        gutterBottom
                    >
                        {errorMessage}
                    </Typography>
                )}

                {activeStep === 0 && (
                    <>
                        <DialogContent
                            sx={{
                                paddingRight: 4,
                                paddingLeft: 4,
                                paddingTop: 4,
                            }}
                        >
                            <DialogContentText>
                                Please, choose where you'd like to import your
                                data from:
                            </DialogContentText>
                            {renderImportOptionsMenu(menuItems)}
                        </DialogContent>
                    </>
                )}

                <DialogActions
                    sx={{
                        paddingRight: 4,
                        paddingLeft: 4,
                        paddingBottom: 4,
                        paddingTop: 2,
                    }}
                >
                    {/* <Button onClick={onClose} variant="outlined">
                        Cancel
                    </Button> */}
                    <Button
                        color="inherit"
                        variant="outlined"
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        sx={{ mr: 1, px: 3, py: 1, fontSize: '0.95rem' }}
                    >
                        Back
                    </Button>
                    {/* {isStepOptional(activeStep) && (
                        <Button
                            color="inherit"
                            onClick={handleSkip}
                            sx={{ mr: 1 }}
                        >
                            Skip
                        </Button>
                    )} */}
                    <LoadingButton
                        color="info"
                        variant="contained"
                        size="large"
                        endIcon={<ArrowForwardIcon />}
                        disabled={!selectedFeeds.length > 0}
                        onClick={handleNext}
                        sx={{ px: 4, py: 1, fontSize: '0.95rem' }}
                    >
                        {activeStep === steps.length - 1 ? 'Visualize' : 'Next'}
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </>
    )
}

function renderImportOptionsMenu(receivedMenuItems) {
    const theme = useTheme()

    return (
        <Container
            sx={{
                py: 1,
                [theme.breakpoints.up('sm')]: {
                    pl: 0,
                },
                pt: 4,
            }}
            maxWidth={false}
        >
            <Grid
                container
                rowSpacing={3}
                justifyContent="flex-start"
                columnSpacing={3}
                alignItems="flex-start"
                pr={0}
            >
                {receivedMenuItems.map(card => (
                    <Grid item key={card.name} alignItems="flex-start" pr={0}>
                        <ImportMenuItem {...card} />
                    </Grid>
                ))}
            </Grid>
        </Container>
    )
}

function generatePresetContext(type) {
    const dateAndTime = new Date()
        .toISOString()
        .slice(2, 16)
        .replace(/-/g, '')
        .replace(/:/g, '')

    if (!type) return `news-${dateAndTime}`

    return `${type}-${dateAndTime}`
}
